import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { contactKeys } from '@/lib/queryKeys';
import { customFieldKeys } from '@/lib/queryKeys';
import { apiPost, operationsClient } from '@/lib/api';

interface BulkCountResult {
  updated?: number;
  deleted?: number;
}

interface BulkAddTagsVars {
  ids: string[];
  tagIds: string[];
}

interface BulkSetCustomFieldVars {
  ids: string[];
  values: { fieldDefinitionId: string; value: unknown }[];
}

interface BulkDeleteVars {
  ids: string[];
}

export function useBulkAddContactTags() {
  const queryClient = useQueryClient();
  return useApiMutation<BulkCountResult, BulkAddTagsVars>({
    mutationFn: (vars) =>
      apiPost<BulkCountResult, BulkAddTagsVars>(operationsClient, '/contacts/bulk-add-tags', vars),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: contactKeys.lists() });
      toast.success(`Tagged ${data.updated ?? 0} contacts`);
    },
  });
}

export function useBulkSetContactCustomField() {
  const queryClient = useQueryClient();
  return useApiMutation<BulkCountResult, BulkSetCustomFieldVars>({
    mutationFn: (vars) =>
      apiPost<BulkCountResult, BulkSetCustomFieldVars>(
        operationsClient,
        '/contacts/bulk-set-custom-field',
        vars,
      ),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: contactKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: customFieldKeys.all() });
      toast.success(`Updated ${data.updated ?? 0} contacts`);
    },
  });
}

export function useBulkDeleteContacts() {
  const queryClient = useQueryClient();
  return useApiMutation<BulkCountResult, BulkDeleteVars>({
    mutationFn: (vars) =>
      apiPost<BulkCountResult, BulkDeleteVars>(operationsClient, '/contacts/bulk-delete', vars),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: contactKeys.lists() });
      toast.success(`Deleted ${data.deleted ?? 0} contacts`);
    },
  });
}
